export const SearchResultHeader = () => <h3 className="font-bold">Search Result</h3>;
